"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypedPlatformFunction = useTypedPlatformFunction;
const hooks_1 = require("../../../../ui/hooks");
function useTypedPlatformFunction(functionDef, baseUrl, tokenProvider) {
    const functionClient = (0, hooks_1.useFunctionClient)(baseUrl, tokenProvider);
    return async (request) => {
        const response = await functionClient.executeFunction({
            functionName: functionDef.name,
            params: functionDef.requestSchema.parse(request),
        });
        return await functionDef.responseSchema.parse(response.result);
    };
}
